const autocompleteModalCloneEquipModel = {
  group: 'Grupo'
};

export default autocompleteModalCloneEquipModel;
